import {
    ArrowLeft,
    ArrowUpDown,
    Bell,
    Building2,
    Calendar,
    CalendarClock,
    Camera,
    ChartBarIncreasing,
    ChartNoAxesColumnIncreasing,
    Check,
    ChevronDown,
    CircleHelp,
    CirclePlus,
    Copy,
    Download,
    Ellipsis,
    Eye,
    FileText,
    Folder,
    Funnel,
    Gauge,
    Globe,
    House,
    ImageIcon,
    Info,
    LayoutGrid,
    ListChecks,
    LogOut,
    Mail,
    Menu,
    Palette,
    Pencil,
    Plug,
    ReceiptEuro,
    ScrollText,
    Search,
    Send,
    Settings,
    Trash,
    Upload,
    User,
    UserCog,
    Users,
    UsersRound,
    X,
    type LucideIcon,
} from 'lucide-react';

/**
 * Every icon the app may draw, by meaning rather than by shape.
 *
 * The first three groups are the client's brand sheet, one on one: the shape
 * named there is the lucide icon here. A screen asks for `billing`, never for
 * `ReceiptEuro`, so swapping a shape is one line in this file.
 *
 * Only this file imports `lucide-react`; everything else goes through `Icon`
 * or `IconTile` (enforced by ESLint).
 */
export const icons = {
    /* Navigatie — merkblad */
    dashboard: LayoutGrid, // grid
    myDay: Calendar, // calendar
    planning: CalendarClock, // calendar met klok
    inspections: House, // house
    survey: FileText, // file-text: Opname NTA 8060
    energyLabel: ChartBarIncreasing, // horizontale balken: Energielabel NTA 8800
    dossiers: Folder, // folder
    reports: ChartNoAxesColumnIncreasing, // bar-chart
    billing: ReceiptEuro, // document met €
    clientPage: Users, // users

    /* Acties — merkblad */
    add: CirclePlus, // plus-circle
    edit: Pencil, // pencil
    delete: Trash, // trash
    copy: Copy, // copy
    upload: Upload, // upload
    download: Download, // download
    takePhoto: Camera, // camera
    photos: ImageIcon, // image
    send: Send, // send
    view: Eye, // eye

    /* Overig — merkblad */
    search: Search, // search
    filter: Funnel, // filter
    sort: ArrowUpDown, // arrow-up-down
    info: Info, // info
    help: CircleHelp, // circle-help
    notifications: Bell, // bell
    settings: Settings, // settings
    profile: User, // user
    logout: LogOut, // log-out

    /* Platformbeheer — niet op het merkblad, in dezelfde lijnstijl */
    platformOverview: Gauge,
    tenants: Building2,
    platformUsers: UserCog,
    questionnaires: ListChecks,
    auditLog: ScrollText,

    /* De tabbladen van Instellingen — niet op het merkblad, in dezelfde lijnstijl.
       Het tabblad Rapport gebruikt `reports`, net als Rapport in de kop van een keuring. */
    company: Building2,
    branding: Palette,
    messages: Mail,
    team: UsersRound,
    domains: Globe,
    integrations: Plug,

    /* Terug naar waar je vandaan komt: de lijst Keuringen, de keuring, Mijn dag */
    back: ArrowLeft,

    /* Bediening binnen de primitives */
    chevronDown: ChevronDown,
    check: Check,
    close: X,
    menu: Menu,
    /* Meer acties achter één knop, zoals het menu in de balk van de opname */
    more: Ellipsis,
} as const satisfies Record<string, LucideIcon>;

export type IconName = keyof typeof icons;
